// extracted by mini-css-extract-plugin
export default {"horizScrollerParent":"r8zRz8zdT8oJenXkRBws"};